import { createContext } from 'react'

import { RequisitionOriginTypeEnum, Supplier } from '@/graphql/purchase-plus/generated/purchasePlus_graphql'

export interface RequisitionOriginContextValue {
  originType: RequisitionOriginTypeEnum | null
  originId: number | null
  originName: string | null
  originSupplier: Pick<Supplier, 'id' | 'name'> | null
  isCustomRequisition: boolean
  isAllSupplierRequisition: boolean
  isSingleSupplierRequisition: boolean
  isBuyListRequisition: boolean
  isReOrderRequisition: boolean
  isStockLocationRequisition: boolean
}

const defaultContextValue: RequisitionOriginContextValue = {
  originType: null,
  originId: null,
  originName: null,
  originSupplier: null,
  isCustomRequisition: false,
  isAllSupplierRequisition: false,
  isSingleSupplierRequisition: false,
  isBuyListRequisition: false,
  isReOrderRequisition: false,
  isStockLocationRequisition: false,
}

export const RequisitionOriginContext = createContext<RequisitionOriginContextValue>(defaultContextValue)
